export { default } from './FatalErrorBoundary';
